var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-icon",class:{'bank':_vm.isBank},domProps:{"innerHTML":_vm._s(_vm.computedIcon)}})}
var staticRenderFns = []

export { render, staticRenderFns }